
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire520c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire520c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $1521a760c0377df4$exports = {};
$parcel$extendImportMap({
    "g8iao": "noaa-badge-full-color.4b1000cc.svg",
    "e64Xx": "hawaii-seal.79ed5714.png",
    "ihnCm": "tsunami-mitigation-logo.1771f8ec.png",
    "ktKV7": "primo-logo.c5315503.png",
    "7NffC": "intl-tsunami-symbol.fea68e5a.svg",
    "lljYM": "facebook-logo.bed12551.svg",
    "bpH67": "twitter-logo.c94ce129.svg"
});

var $58eedc976c0db041$var$n, $58eedc976c0db041$export$41c562ebe57d11e2, $58eedc976c0db041$var$u, $58eedc976c0db041$export$a8257692ac88316c, $58eedc976c0db041$var$t, $58eedc976c0db041$var$o, $58eedc976c0db041$var$r, $58eedc976c0db041$var$f = {}, $58eedc976c0db041$var$e = [], $58eedc976c0db041$var$c = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $58eedc976c0db041$var$s(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $58eedc976c0db041$var$a(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $58eedc976c0db041$export$c8a8987d4410bf2d(l, u, i) {
    var t, o, r, f = {};
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $58eedc976c0db041$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $58eedc976c0db041$var$v(l, f, t, o, null);
}
function $58eedc976c0db041$var$v(n, i, t, o, r) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$58eedc976c0db041$var$u : r
    };
    return null == r && null != $58eedc976c0db041$export$41c562ebe57d11e2.vnode && $58eedc976c0db041$export$41c562ebe57d11e2.vnode(f), f;
}
function $58eedc976c0db041$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $58eedc976c0db041$export$ffb0004e005737fa(n) {
    return n.children;
}
function $58eedc976c0db041$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $58eedc976c0db041$var$_(n, l) {
    if (null == l) return n.__ ? $58eedc976c0db041$var$_(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $58eedc976c0db041$var$_(n) : null;
}
function $58eedc976c0db041$var$k(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $58eedc976c0db041$var$k(n);
    }
}
function $58eedc976c0db041$var$b(n) {
    (!n.__d && (n.__d = !0) && $58eedc976c0db041$var$t.push(n) && !$58eedc976c0db041$var$g.__r++ || $58eedc976c0db041$var$o !== $58eedc976c0db041$export$41c562ebe57d11e2.debounceRendering) && (($58eedc976c0db041$var$o = $58eedc976c0db041$export$41c562ebe57d11e2.debounceRendering) || setTimeout)($58eedc976c0db041$var$g);
}
function $58eedc976c0db041$var$g() {
    for(var n; $58eedc976c0db041$var$g.__r = $58eedc976c0db041$var$t.length;)n = $58eedc976c0db041$var$t.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), $58eedc976c0db041$var$t = [], n.some(function(n) {
        var l, u, i, t, o, r;
        n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = $58eedc976c0db041$var$s({}, t)).__v = t.__v + 1, $58eedc976c0db041$var$j(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [
            o
        ] : null, u, null == o ? $58eedc976c0db041$var$_(t) : o, t.__h), $58eedc976c0db041$var$z(u, t), t.__e != o && $58eedc976c0db041$var$k(t)));
    });
}
function $58eedc976c0db041$var$w(n, l, u, i, t, o, r, c, s, a) {
    var h, y, d, k, b, g, w, x = i && i.__k || $58eedc976c0db041$var$e, C = x.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (k = u.__k[h] = null == (k = l[h]) || "boolean" == typeof k ? null : "string" == typeof k || "number" == typeof k || "bigint" == typeof k ? $58eedc976c0db041$var$v(null, k, null, null, k) : Array.isArray(k) ? $58eedc976c0db041$var$v($58eedc976c0db041$export$ffb0004e005737fa, {
        children: k
    }, null, null, null) : k.__b > 0 ? $58eedc976c0db041$var$v(k.type, k.props, k.key, null, k.__v) : k)) {
        if (k.__ = u, k.__b = u.__b + 1, null === (d = x[h]) || d && k.key == d.key && k.type === d.type) x[h] = void 0;
        else for(y = 0; y < C; y++){
            if ((d = x[y]) && k.key == d.key && k.type === d.type) {
                x[y] = void 0;
                break;
            }
            d = null;
        }
        $58eedc976c0db041$var$j(n, k, d = d || $58eedc976c0db041$var$f, t, o, r, c, s, a), b = k.__e, (y = k.ref) && d.ref != y && (w || (w = []), d.ref && w.push(d.ref, null, k), w.push(y, k.__c || b, k)), null != b ? (null == g && (g = b), "function" == typeof k.type && k.__k === d.__k ? k.__d = s = $58eedc976c0db041$var$m(k, s, n) : s = $58eedc976c0db041$var$A(n, k, d, x, b, s), "function" == typeof u.type && (u.__d = s)) : s && d.__e == s && s.parentNode != n && (s = $58eedc976c0db041$var$_(d));
    }
    for(u.__e = g, h = C; h--;)null != x[h] && ("function" == typeof u.type && null != x[h].__e && x[h].__e == u.__d && (u.__d = $58eedc976c0db041$var$_(i, h + 1)), $58eedc976c0db041$var$N(x[h], x[h]));
    if (w) for(h = 0; h < w.length; h++)$58eedc976c0db041$var$M(w[h], w[++h], w[++h]);
}
function $58eedc976c0db041$var$m(n, l, u) {
    for(var i, t = n.__k, o = 0; t && o < t.length; o++)(i = t[o]) && (i.__ = n, l = "function" == typeof i.type ? $58eedc976c0db041$var$m(i, l, u) : $58eedc976c0db041$var$A(u, i, i, t, i.__e, l));
    return l;
}
function $58eedc976c0db041$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $58eedc976c0db041$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $58eedc976c0db041$var$A(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function $58eedc976c0db041$var$C(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $58eedc976c0db041$var$H(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $58eedc976c0db041$var$H(n, o, l[o], u[o], i);
}
function $58eedc976c0db041$var$$(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || $58eedc976c0db041$var$c.test(l) ? u : u + "px";
}
function $58eedc976c0db041$var$H(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $58eedc976c0db041$var$$(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $58eedc976c0db041$var$$(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? $58eedc976c0db041$var$T : $58eedc976c0db041$var$I, o) : n.removeEventListener(l, o ? $58eedc976c0db041$var$T : $58eedc976c0db041$var$I, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
    }
}
function $58eedc976c0db041$var$I(n) {
    this.l[n.type + !1]($58eedc976c0db041$export$41c562ebe57d11e2.event ? $58eedc976c0db041$export$41c562ebe57d11e2.event(n) : n);
}
function $58eedc976c0db041$var$T(n) {
    this.l[n.type + !0]($58eedc976c0db041$export$41c562ebe57d11e2.event ? $58eedc976c0db041$export$41c562ebe57d11e2.event(n) : n);
}
function $58eedc976c0db041$var$j(n, u, i, t, o, r, f, e, c) {
    var a, h, v, y, _, k, b, g, m, x, A, C, $, H = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (a = $58eedc976c0db041$export$41c562ebe57d11e2.__b) && a(u);
    try {
        n: if ("function" == typeof H) {
            if (g = u.props, m = (a = H.contextType) && t[a.__c], x = a ? m ? m.props.value : a.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in H && H.prototype.render ? u.__c = h = new H(g, x) : (u.__c = h = new $58eedc976c0db041$export$16fa2f45be04daa8(g, x), h.constructor = H, h.render = $58eedc976c0db041$var$O), m && m.sub(h), h.props = g, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != H.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $58eedc976c0db041$var$s({}, h.__s)), $58eedc976c0db041$var$s(h.__s, H.getDerivedStateFromProps(g, h.__s))), y = h.props, _ = h.state, v) null == H.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
            else {
                if (null == H.getDerivedStateFromProps && g !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(g, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(g, h.__s, x) || u.__v === i.__v) {
                    h.props = g, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), h.__h.length && f.push(h);
                    break n;
                }
                null != h.componentWillUpdate && h.componentWillUpdate(g, h.__s, x), null != h.componentDidUpdate && h.__h.push(function() {
                    h.componentDidUpdate(y, _, k);
                });
            }
            if (h.context = x, h.props = g, h.__v = u, h.__P = n, A = $58eedc976c0db041$export$41c562ebe57d11e2.__r, C = 0, "prototype" in H && H.prototype.render) h.state = h.__s, h.__d = !1, A && A(u), a = h.render(h.props, h.state, h.context);
            else do h.__d = !1, A && A(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
            while (h.__d && ++C < 25);
            h.state = h.__s, null != h.getChildContext && (t = $58eedc976c0db041$var$s($58eedc976c0db041$var$s({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, _)), $ = null != a && a.type === $58eedc976c0db041$export$ffb0004e005737fa && null == a.key ? a.props.children : a, $58eedc976c0db041$var$w(n, Array.isArray($) ? $ : [
                $
            ], u, i, t, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $58eedc976c0db041$var$L(i.__e, u, i, t, o, r, f, c);
        (a = $58eedc976c0db041$export$41c562ebe57d11e2.diffed) && a(u);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $58eedc976c0db041$var$z(n, u) {
    $58eedc976c0db041$export$41c562ebe57d11e2.__c && $58eedc976c0db041$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $58eedc976c0db041$var$L(l, u, i, t, o, r, e, c) {
    var s, h, v, y = i.props, p = u.props, d = u.type, k = 0;
    if ("svg" === d && (o = !0), null != r) {
        for(; k < r.length; k++)if ((s = r[k]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, r[k] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), r = null, c = !1;
    }
    if (null === d) y === p || c && l.data === p || (l.data = p);
    else {
        if (r = r && $58eedc976c0db041$var$n.call(l.childNodes), h = (y = i.props || $58eedc976c0db041$var$f).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !c) {
            if (null != r) for(y = {}, k = 0; k < l.attributes.length; k++)y[l.attributes[k].name] = l.attributes[k].value;
            (v || h) && (v && (h && v.__html == h.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
        }
        if ($58eedc976c0db041$var$C(l, p, y, o, c), v) u.__k = [];
        else if (k = u.props.children, $58eedc976c0db041$var$w(l, Array.isArray(k) ? k : [
            k
        ], u, i, t, o && "foreignObject" !== d, r, e, r ? r[0] : i.__k && $58eedc976c0db041$var$_(i, 0), c), null != r) for(k = r.length; k--;)null != r[k] && $58eedc976c0db041$var$a(r[k]);
        c || ("value" in p && void 0 !== (k = p.value) && (k !== l.value || "progress" === d && !k || "option" === d && k !== y.value) && $58eedc976c0db041$var$H(l, "value", k, y.value, !1), "checked" in p && void 0 !== (k = p.checked) && k !== l.checked && $58eedc976c0db041$var$H(l, "checked", k, y.checked, !1));
    }
    return l;
}
function $58eedc976c0db041$var$M(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $58eedc976c0db041$var$N(n, u, i) {
    var t, o;
    if ($58eedc976c0db041$export$41c562ebe57d11e2.unmount && $58eedc976c0db041$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $58eedc976c0db041$var$M(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $58eedc976c0db041$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null;
    }
    if (t = n.__k) for(o = 0; o < t.length; o++)t[o] && $58eedc976c0db041$var$N(t[o], u, "function" != typeof n.type);
    i || null == n.__e || $58eedc976c0db041$var$a(n.__e), n.__e = n.__d = void 0;
}
function $58eedc976c0db041$var$O(n, l, u) {
    return this.constructor(n, u);
}
function $58eedc976c0db041$export$b3890eb0ae9dca99(u, i, t) {
    var o, r, e;
    $58eedc976c0db041$export$41c562ebe57d11e2.__ && $58eedc976c0db041$export$41c562ebe57d11e2.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, e = [], $58eedc976c0db041$var$j(i, u = (!o && t || i).__k = $58eedc976c0db041$export$c8a8987d4410bf2d($58eedc976c0db041$export$ffb0004e005737fa, null, [
        u
    ]), r || $58eedc976c0db041$var$f, $58eedc976c0db041$var$f, void 0 !== i.ownerSVGElement, !o && t ? [
        t
    ] : r ? null : i.firstChild ? $58eedc976c0db041$var$n.call(i.childNodes) : null, e, !o && t ? t : r ? r.__e : i.firstChild, o), $58eedc976c0db041$var$z(e, u);
}
function $58eedc976c0db041$export$fa8d919ba61d84db(n, l) {
    $58eedc976c0db041$export$b3890eb0ae9dca99(n, l, $58eedc976c0db041$export$fa8d919ba61d84db);
}
function $58eedc976c0db041$export$e530037191fcd5d7(l, u, i) {
    var t, o, r, f = $58eedc976c0db041$var$s({}, l.props);
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $58eedc976c0db041$var$n.call(arguments, 2) : i), $58eedc976c0db041$var$v(l.type, f, t || l.key, o || l.ref, null);
}
function $58eedc976c0db041$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $58eedc976c0db041$var$r++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some($58eedc976c0db041$var$b);
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$58eedc976c0db041$var$n = $58eedc976c0db041$var$e.slice, $58eedc976c0db041$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, o, r; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((o = t.constructor) && null != o.getDerivedStateFromError && (t.setState(o.getDerivedStateFromError(n)), r = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), r = t.__d), r) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $58eedc976c0db041$var$u = 0, $58eedc976c0db041$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $58eedc976c0db041$var$s({}, this.state), "function" == typeof n && (n = n($58eedc976c0db041$var$s({}, u), this.props)), n && $58eedc976c0db041$var$s(u, n), null != n && this.__v && (l && this.__h.push(l), $58eedc976c0db041$var$b(this));
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $58eedc976c0db041$var$b(this));
}, $58eedc976c0db041$export$16fa2f45be04daa8.prototype.render = $58eedc976c0db041$export$ffb0004e005737fa, $58eedc976c0db041$var$t = [], $58eedc976c0db041$var$g.__r = 0, $58eedc976c0db041$var$r = 0;




var $d631070deacf9eb1$exports = {};
$d631070deacf9eb1$exports = $parcel$resolve("g8iao");


var $673363e62cb3e9cc$exports = {};
$673363e62cb3e9cc$exports = $parcel$resolve("e64Xx");


var $896cb8fb639a41df$exports = {};
$896cb8fb639a41df$exports = $parcel$resolve("ihnCm");


var $d2424d4b1d1d8280$exports = {};
$d2424d4b1d1d8280$exports = $parcel$resolve("ktKV7");


class $f8f3fe42a902eb30$export$2e2bcd8739ae039 extends (0, $58eedc976c0db041$export$16fa2f45be04daa8) {
    constructor(){
        super();
        this.hawaiiCode = 'hi';
        this.guamCode = 'gu';
        this.state = {
            hasBeenOpened: false
        };
    }
    getClass() {
        if (this.props.isOpen) {
            if (!this.state.hasBeenOpened) this.setState({
                hasBeenOpened: true
            });
            return 'slide-panel-bottom-show';
        } else if (this.props.isOpen === false && this.state.hasBeenOpened) return 'slide-panel-bottom-hide';
        else return '';
    }
    render() {
        const self = this;
        return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $58eedc976c0db041$export$ffb0004e005737fa), null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("footer", {
            class: `footer ${self.getClass()}`
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "footer-inner"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
            role: "button",
            class: "btn-close--dark",
            onclick: self.props.close
        }, "\xD7"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "column"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h4", null, "About this Map"), this.props.currentLocation === this.hawaiiCode && [
            (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "This map depicts the tsunami evacuation zones developed by your local emergency management or county civil defense agency. These evacuation zones provide the minimum safe evacuation distance."),
            (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "This information is also available in your local telephone directory and from your county civil defense agency.")
        ], this.props.currentLocation === this.guamCode && [
            (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "This map depicts the tsunami evacuation zones (shaded in pink) developed by your local emergency management agency. These evacuation zones provide the minimum safe evacuation distance."),
            (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "This information is also available in your local telephone directory and from your emergency management agency.")
        ], (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "In the event of a locally generated tsunami, you may only have minutes to evacuate. If the ground is shaking, a locally generated tsunami may be occurring. Move to higher ground immediately, well away from the evacuation zone and low-lying coastal areas."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Website Owner: ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://coast.noaa.gov/",
            target: "_blank",
            rel: "noreferrer"
        }, "NOAA Office for Coastal Management "), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("br", null), "Page Reviewed: November 12, 2015")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "column"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h4", null, "About this Site"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "This site has been developed by the ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "http://www.tsunami.noaa.gov/",
            title: "Go to tsunami.noaa.gov",
            target: "_blank",
            rel: "noreferrer"
        }, "National Oceanic and Atmospheric Administration"), " (NOAA) in partnership with the State of Hawai'i."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://coast.noaa.gov/survey.html",
            target: "_blank",
            rel: "noreferrer"
        }, "Customer Satisfaction Survey")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "mailto:psc@noaa.gov?subject=Feedback from Tsunami",
            title: "Email Feedback",
            target: "_blank",
            rel: "noreferrer"
        }, "For feedback, contact the NOAA Office for Coastal Management - Pacific Islands")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "//coast.noaa.gov/PrivacyPolicy/privacyPolicy.html",
            title: "Privacy Policy",
            target: "_blank",
            rel: "noreferrer"
        }, "Privacy Policy")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "javascript:alert('The data and maps in this tool illustrate the scale of potential inundation from a hypothetical tsunami, not the exact location, and do not account for all physical or anthropogenic processes. The data and maps in this tool are provided \u201Cas is,\u201D without warranty to their performance, merchantable state, or fitness for any particular purpose. The entire risk associated with the results and performance of these data is assumed by the user. This tool should be used strictly as an evacuation planning reference tool and not for navigation, permitting, or other legal purposes.');"
        }, "Disclaimer")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "//coast.noaa.gov/ocm-accessibility-disclaimer.html",
            target: "_blank",
            rel: "noreferrer",
            title: "Accessibility Statement"
        }, "Accessibility Statement")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "//coast.noaa.gov/digitalcoast",
            target: "_blank",
            rel: "noreferrer",
            title: "Visit Site"
        }, "Provided by NOAA's DigitalCoast")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://noaa.gov",
            title: "Go to noaa.gov",
            target: "_blank",
            rel: "noreferrer",
            class: "partner-logo"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d631070deacf9eb1$exports))),
            alt: "NOAA logo",
            width: "80"
        })), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://www.scd.hawaii.gov/",
            title: "Go to State of Hawaii site",
            target: "_blank",
            rel: "noreferrer",
            class: "partner-logo"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($673363e62cb3e9cc$exports))),
            alt: "Seal of the State of Hawaii",
            width: "80",
            height: "80"
        })), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://nws.weather.gov/nthmp/",
            title: "Go to Tsunami Hazard Mitigation Program website",
            target: "_blank",
            rel: "noreferrer",
            class: "partner-logo"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($896cb8fb639a41df$exports))),
            alt: "Tsunami Hazard Mitigation Program Logo"
        })), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://coast.noaa.gov/primo/",
            title: "Go to Primo website",
            target: "_blank",
            rel: "noreferrer",
            class: "partner-logo"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d2424d4b1d1d8280$exports))),
            alt: "Primo Logo",
            width: "80"
        }))))));
    }
}



class $6112bc75225f2df5$export$2e2bcd8739ae039 extends (0, $58eedc976c0db041$export$16fa2f45be04daa8) {
    constructor(){
        super();
        this.state = {
            hasBeenOpened: false,
            isOpen: false
        };
    }
    getClass() {
        if (this.props.isOpen) {
            if (!this.state.hasBeenOpened) this.setState({
                hasBeenOpened: true
            });
            return 'slide-panel-right-show';
        } else if (this.props.isOpen === false && this.state.hasBeenOpened) return 'slide-panel-right-hide';
        else return '';
    }
    render() {
        const self = this;
        return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $58eedc976c0db041$export$ffb0004e005737fa), null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("aside", {
            class: `slide-panel--right ${self.getClass()}`
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
            class: "btn-close-important",
            onclick: self.props.close
        }, "\xD7"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "slide-panel--inner"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", {
            class: "font-light"
        }, "Important Information"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "scroller",
            tabindex: "0"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Strong earthquakes"), " may cause tsunamis: If the shaking causes you to fall or have difficulty standing, protect yourself from the earthquake. When the shaking stops, leave the evacuation zone immediately."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Know the warning signs"), ": As a tsunami approaches the shoreline, it could possibly expose the ocean floor, reef, and fish. You might see an approaching wall of water or hear a roar similar to that of a train or jet aircraft. If so, leave the evacuation zone immediately."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, " When a Tsunami Watch is issued"), ", local officials will begin to plan for response and evacuations. You should also begin to prepare by finding out if you are currently in the evacuation zone and begin to contact family and loved ones."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "When a Tsunami Advisory is issued"), ", there will be no coastal evacuations; however officials will evacuate the ocean and beaches. Stay out of the ocean and away from beaches, and stay out of any canals or streams that feed directly from the ocean."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Outdoor warning sirens"), " are activated by your local emergency management or county civil defense agency to notify the public of potential hazards. When you hear a siren, turn on the nearest radio or television and listen for emergency information and instructions."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Remain at least 100 feet away"), " from inland waterways and marinas connected to the ocean because of wave surges and possible flooding."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "For all Tsunami Warnings"), ", evacuate out of the red zone. In the unlikely case of an \"Extreme Tsunami Warning\" (applicable in Hawai'i only), evacuate out of the red and yellow zones."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Boaters"), " should move vessels to at least 50 fathoms (300 ft) deep and 2 nautical miles away from harbor entrances; follow all directions from the Captain of the Port."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Structural steel or reinforced concrete"), " buildings of ten or more stories provide increased protection on or above the fourth floor; if you are caught near the shoreline consider using vertical evacuation."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "The evacuation zone"), " is a guideline and should be considered the minimum safe evacuation distance."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "These maps do not"), " consider the destructive effects of a locally generated tsunami. If you feel shaking, move inland immediately, well inland from the red tsunami evacuation zone.")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "box"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h3", {
            class: "font-light"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("center", null, "For real-time information visit")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("center", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://www.tsunami.gov/",
            target: "_blank",
            rel: "noreferrer"
        }, "NOAA Tsunami Warning Center")))))));
    }
}



var $3839d5208e8bbfba$exports = {};
$3839d5208e8bbfba$exports = JSON.parse("[{\"name\":\"Hawai'i\",\"title\":\"Hawaii\",\"telephone\":\"8087334300\",\"nearbyDistanceMeters\":1300000,\"mapOptions\":{\"state\":\"hi\",\"center\":{\"lat\":20.5,\"lng\":-157.8},\"zoom\":7,\"maxZoom\":17,\"mapTypeId\":\"roadmap\"}},{\"name\":\"Guam\",\"title\":\"Guam\",\"telephone\":\"6714759600\",\"nearbyDistanceMeters\":500000,\"bbox\":{\"top\":13.1783003,\"left\":144.3605469,\"bottom\":13.1940717,\"right\":145.2394531},\"mapOptions\":{\"state\":\"gu\",\"center\":{\"lat\":13.45,\"lng\":144.8},\"zoom\":10,\"maxZoom\":17,\"mapTypeId\":\"terrain\"}}]");


// should not end with a slash
const $4c3d9a687966aff3$export$f28b19003f47c57 = 'https://tiles.arcgis.com/tiles/C8EMgrsFcRFL6LrL/arcgis/rest/services/Tsunami_Evacuation_Zones/MapServer/tile';
// Legend config
// colorId maps to the layerId in the MapServer legend endpoint
const $4c3d9a687966aff3$export$9a9b59e08de24cef = {
    layerBaseUrl: 'https://tiles.arcgis.com/tiles/C8EMgrsFcRFL6LrL/arcgis/rest/services/Tsunami_Evacuation_Zones/MapServer',
    items: [
        {
            colorId: 6,
            name: 'Tsunami Evacuation Zone'
        },
        {
            colorId: 7,
            name: 'Extreme Tsunami Evacuation Zone'
        },
        {
            colorId: 8,
            name: 'Safe Zone'
        }
    ]
};
const $4c3d9a687966aff3$export$b4c72b75ca68e4b7 = 0.5;


class $7e0737d55809caa4$export$2e2bcd8739ae039 extends (0, $58eedc976c0db041$export$16fa2f45be04daa8) {
    constructor(){
        super();
        const self = this;
        this.getLegendInfo().then((legend)=>{
            self.legendItems = legend;
        });
        this.state = {
            isLegendOpen: false,
            areContactsOpen: false
        };
    }
    async getLegendInfo() {
        try {
            const response = await fetch(`${(0, $4c3d9a687966aff3$export$9a9b59e08de24cef).layerBaseUrl}/legend?f=json`);
            const legendData = await response.json();
            return (0, $4c3d9a687966aff3$export$9a9b59e08de24cef).items.map((item)=>{
                let swatchSrc = null;
                try {
                    const layer = legendData.layers.find((x)=>x.layerId === item.colorId);
                    if (layer?.legend?.[0]?.imageData) swatchSrc = `data:${layer.legend[0].contentType};base64,${layer.legend[0].imageData}`;
                } catch (err) {
                    console.error(err);
                }
                return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", {
                    class: "legend-item"
                }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
                    class: "legend-symbol",
                    style: swatchSrc ? `background-image: url('${swatchSrc}'); background-size: cover;` : ''
                }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
                    class: "legend-item-label"
                }, item.name));
            });
        } catch (err) {
            console.log(err);
            console.log(`Could not load legend: ${err}`);
        }
    }
    formatTelephone(telephone) {
        if (telephone.length !== 10) return telephone;
        return `(${telephone.slice(0, 3)}) ${telephone.slice(3, 6)}-${telephone.slice(6, 10)}`;
    }
    openImportantInfo() {
        this.props.openImportantInfo();
    }
    openTsunamiInfo() {
        this.props.openTsunamiInfo();
    }
    toggleLegend() {
        this.setState({
            isLegendOpen: !this.state.isLegendOpen
        });
        this.setState({
            areContactsOpen: false
        });
    }
    toggleContacts() {
        this.setState({
            areContactsOpen: !this.state.areContactsOpen
        });
        this.setState({
            isLegendOpen: false
        });
    }
    render() {
        const self = this;
        return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $58eedc976c0db041$export$ffb0004e005737fa), null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
            class: "btn-orange btn-important-info-toggle",
            onclick: ()=>self.openImportantInfo(),
            "data-ga": "Menu: Important Information"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "icon noclick"
        }, "!"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "hide-small button-text noclick"
        }, "Important Information")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
            class: "btn-dark btn-tsunami-info-toggle",
            onclick: ()=>self.openTsunamiInfo(),
            "data-ga": "Menu: Tsunami Information"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "icon noclick"
        }, "?"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "hide-small button-text noclick"
        }, "Tsunami Information")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "widget widget-legend"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
            class: "btn-dark",
            onclick: ()=>self.toggleLegend(),
            "data-ga": "Menu: Legend"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "icon noclick"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "hamburger-line noclick"
        }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "hamburger-line noclick"
        }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "hamburger-line noclick"
        })), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "button-text hide-small noclick"
        }, "Legend")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: `dropdown-menu center legend ${self.state.isLegendOpen ? 'is-open' : ''}`
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "arrow"
        }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("ul", {
            role: "list",
            class: "legend-list"
        }, self.legendItems))), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "widget widget-number-dropdown"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
            class: "btn-dark",
            onclick: ()=>self.toggleContacts(),
            "data-ga": "Menu: Emergency Number"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "icon center noclick"
        }, "#"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "text-hidden noclick button-text"
        }, "Emergency Contacts")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: `dropdown-menu right ${self.state.areContactsOpen ? 'is-open' : ''}`
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "arrow"
        }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "dropdown-title"
        }, "Emergency Number"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", {
            class: "dropdown-item"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("small", null, self.props.selectedRegion.name, ": ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            tel: self.props.selectedRegion.telephone,
            title: `${self.props.selectedRegion.name} Emergency Management Telephone Number`,
            class: "telephone-number"
        }, self.formatTelephone(self.props.selectedRegion.telephone)))))));
    }
}




class $0236e83dd00b8ae9$var$MapService {
    changeRegion(region) {
        this.map.setOptions(region.mapOptions);
    }
    initializeMap(mapElement) {
        const self = this;
        self.map = new google.maps.Map(mapElement, {
            panControl: false,
            streetViewControl: false,
            zoomControl: true,
            active: true,
            fullscreenControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            }
        });
        // get tile layer
        const cachelayer = new google.maps.ImageMapType({
            getTileUrl: function(coord, zoom) {
                const normalizedCoord = getNormalizedCoord(coord, zoom);
                if (!normalizedCoord) return;
                return `${0, $4c3d9a687966aff3$export$f28b19003f47c57}/${parseFloat(zoom)}/${normalizedCoord.y}/${normalizedCoord.x}`;
            },
            tileSize: new google.maps.Size(256, 256),
            opacity: (0, $4c3d9a687966aff3$export$b4c72b75ca68e4b7)
        });
        // function copied from the google api reference
        function getNormalizedCoord(coord, zoom) {
            const y = coord.y;
            let x = coord.x;
            // tile range in one direction range is dependent on zoom level
            // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc
            const tileRange = 1 << zoom;
            // don't repeat across y-axis (vertically)
            if (y < 0 || y >= tileRange) return null;
            // repeat across x-axis
            if (x < 0 || x >= tileRange) x = (x % tileRange + tileRange) % tileRange;
            return {
                x: x,
                y: y
            };
        }
        self.map.overlayMapTypes.push(cachelayer);
        self.geocoder = new google.maps.Geocoder();
        new google.maps.places.PlacesService(self.map);
    }
    initializeSearch(searchElement, searchCallback) {
        const self = this;
        this.searchCallback = searchCallback;
        const autocomplete = new google.maps.places.Autocomplete(searchElement);
        autocomplete.addListener('place_changed', ()=>onPlaceChanged(this));
        function onPlaceChanged(mapService) {
            const place = autocomplete.getPlace();
            mapService.setPlace(place);
            self.searchCallback(place, google.maps.GeocoderStatus.OK);
        }
    }
    searchLocation(searchStr) {
        const self = this;
        self.geocoder.geocode({
            address: searchStr
        }, (results, status)=>{
            let place = null;
            if (status === google.maps.GeocoderStatus.OK) {
                place = results[0];
                self.setPlace(place);
            }
            self.searchCallback(place, status);
        });
    }
    setPlace(place) {
        let gmarkers = [];
        if (place.geometry) {
            for(let i = 0; i < gmarkers.length; i++)gmarkers[i].setMap(this.map);
            gmarkers = [];
            const marker = new google.maps.Marker({
                position: place.geometry.location
            });
            gmarkers.push(marker);
            marker.setMap(this.map);
            this.map.panTo(place.geometry.location);
            this.map.setZoom(15);
        }
    }
}
var $0236e83dd00b8ae9$export$2e2bcd8739ae039 = new $0236e83dd00b8ae9$var$MapService();


class $32ff908c8de8b49f$export$2e2bcd8739ae039 extends (0, $58eedc976c0db041$export$16fa2f45be04daa8) {
    componentDidMount() {
        (0, $0236e83dd00b8ae9$export$2e2bcd8739ae039).initializeMap(this.mapElement);
    }
    render() {
        const self = this;
        return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $58eedc976c0db041$export$ffb0004e005737fa), null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("main", {
            class: "map",
            id: "tsunami-map",
            ref: (m)=>{
                self.mapElement = m;
            }
        }));
    }
}




var $6e2819d8e1d98769$export$2e2bcd8739ae039 = (eventName, eventData)=>{
    dataLayer.push({
        event: eventName,
        ...eventData
    });
};


class $2209c6e17d6af860$export$2e2bcd8739ae039 extends (0, $58eedc976c0db041$export$16fa2f45be04daa8) {
    constructor(){
        super();
        this.state = {
            searchValue: ''
        };
    }
    onKeyDown(e) {
        if (e.keyCode === 13) // The ENTER key
        this.submitSearch(e.target.value);
    }
    onChange(e) {
        this.setState({
            searchValue: e.target.value
        });
    }
    submitSearch(searchStr) {
        if (searchStr) (0, $0236e83dd00b8ae9$export$2e2bcd8739ae039).searchLocation(searchStr);
    }
    onPlaceChanged(place, status) {
        if (place) {
            if (place.geometry) {
                (0, $6e2819d8e1d98769$export$2e2bcd8739ae039)('search', {
                    formatted_address: place.formatted_address
                });
                this.searchElement.value = place.formatted_address;
                this.setState({
                    searchValue: place.formatted_address
                });
            }
        } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) alert('No location found for search');
        else {
            console.error(status);
            alert('Search failed unexpectedly');
        }
    }
    componentDidMount() {
        (0, $0236e83dd00b8ae9$export$2e2bcd8739ae039).initializeSearch(this.searchElement, (place, status)=>this.onPlaceChanged(place, status));
    }
    render() {
        const self = this;
        return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $58eedc976c0db041$export$ffb0004e005737fa), null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("form", {
            class: "widget widget-search",
            role: "search",
            onkeydown: (e)=>e.keycode !== 13,
            onsubmit: (e)=>e.preventDefault()
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("label", {
            for: "search",
            class: "hidden"
        }, "Search"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("input", {
            type: "text",
            name: "search",
            id: "search",
            placeholde: "Search for an Address",
            value: self.state.searchValue,
            onchange: (e)=>self.onChange(e),
            onkeydown: (e)=>self.onKeyDown(e),
            "data-ga": "Search Input",
            ref: (s)=>{
                self.searchElement = s;
            }
        }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
            type: "button",
            onclick: (e)=>self.submitSearch(self.state.searchValue),
            "data-ga": "Search Button"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "text-hidden"
        }, "Submit"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "no-search"
        }))));
    }
}



class $d3073650918105ac$export$2e2bcd8739ae039 extends (0, $58eedc976c0db041$export$16fa2f45be04daa8) {
    constructor(){
        super();
        // should match the 'name' attribute in the region configuration
        this.hawaiiCode = "Hawai'i";
        this.guamCode = 'Guam';
    }
    render() {
        const self = this;
        return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $58eedc976c0db041$export$ffb0004e005737fa), null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("aside", {
            class: `modal-full-page ${self.props.isOpen ? 'is-open' : ''}`
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
            class: "btn-close--dark",
            onclick: self.props.close
        }, "\xD7"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("section", {
            role: "document",
            class: "content"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("article", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h1", {
            class: "section-head"
        }, "Tsunami Warning"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", {
            class: "font-light"
        }, "Know the Natural Warning Signs of a Tsunami -  use your senses!"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h3", null, "FEEL"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("em", null, "Feel the ground shaking severely?")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Head for higher ground. Strong local earthquakes may cause tsunamis."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h3", null, "SEE"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("em", null, "See an unusual disappearance of water, or an oncoming wall of water?")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Immediately leave low-lying coastal areas and move inland. As a tsunami approaches the shoreline, sea levels often recede,exposing the ocean floor, reef, and fish."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h3", null, "HEAR"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("em", null, "Hear the roar?")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "An approaching tsunami may create a loud \u201Croaring\u201D similar to the sound of a moving train or jet aircraft."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "http://itic.ioc-unesco.org/images/stories/awareness_and_education/tsunami_safety_flyers/sensing_a_tsunami_en_20130912.pdf",
            title: "Download Warning Signs PDF",
            target: "_blank",
            rel: "noreferrer",
            class: "link-block--dark"
        }, "Find and Share a Printable Version of this Information"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", null, "Official Tsunami Warnings"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "NOAA\u2019s ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://www.tsunami.gov/",
            title: "Go to Tsunami Warning Center site",
            target: "_blank",
            rel: "noreferrer"
        }, "Tsunami Warning Center"), " (TWC) is responsible for tsunami monitoring and issuing necessary watches or warnings for Hawai\u2018i and the U.S. Pacific Islands."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h3", null, "Tsunami Message Definitions"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "text-important"
        }, "Tsunami Warning:"), " Take Action"), "- Danger! A tsunami that may cause widespread flooding is expected or occurring. Dangerous coastal flooding and powerful currents are possible and may continue for several hours or days after initial arrival. Follow instructions from local officials. Evacuation is recommended. Move to high ground or inland (away from the water)."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "text-important"
        }, "Tsunami Advisory:"), " Take Action"), "- A tsunami with potential for strong currents or waves dangerous to those in or very near the water is expected or occurring. There may be flooding of beach and harbor areas. Stay out of the water and away from beaches and waterways. Follow instructions from local officials."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "text-important"
        }, "Tsunami Watch:"), " Be Aware"), "- A distant earthquake has occurred. A tsunami is possible.  Stay tuned for more information. Be prepared to take action if necessary."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "text-important"
        }, "Tsunami Information Statement:"), " Relax"), "- An earthquake has occurred, or a tsunami warning, advisory or watch has been issued for another part of the ocean. Most information statements indicate there is no threat of a destructive tsunami."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", null, "Emergency Information"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "The ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Emergency Alert System"), ", often called the EAS, is used to notify the public of approaching hazards. The EAS will be activated along with other warning methods such as the Outdoor Siren Warning System, Wireless Emergency Alerts, and local emergency notification systems."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "If you are alerted about a tsunami hazard by any of the above methods, turn on the nearest radio or television and listen for emergency information and instructions."), self.props.selectedRegion.name === self.hawaiiCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Foreign language emergency broadcasts can be found on the following stations: KZOO 1210AM (Japanese), KREA 1540AM (Korean), and KNDI 1270AM (variety of Pacific Islander languages)."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://dod.hawaii.gov/hiema/",
            title: "Go to Hawai'i Emergency Management Agency",
            target: "_blank",
            rel: "noreferrer",
            class: "link-block--dark"
        }, "Hawai'i Emergency Management Agency")), self.props.selectedRegion.name === self.guamCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h5", null, "Guam Homeland Security"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "http://ghs.guam.gov/",
            title: "Go to Guam Homeland Security Office of Civil Defense",
            target: "_blank",
            rel: "noreferrer",
            class: "link-block--dark"
        }, "Guam Homeland Security Office of Civil Defense"))), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("article", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h1", {
            class: "section-head"
        }, "Tsunami Evacuation"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "If you are in a low-lying area near the coast or in the tsunami evacuation zone and you feel shaking that causes you to fall or have difficulty standing, get to higher ground immediately. A locally generated tsunami could reach the shore within minutes!"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", null, "Evacuation Tips"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Tune in to your local television or radio stations for the most up-to-date information about tsunami evacuation centers in your area."), self.props.selectedRegion.name === self.hawaiiCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, " ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "For questions about evacuation procedures in your community, contact your county emergency management agency:"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("ul", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            title: "Go to site",
            target: "_blank",
            rel: "noreferrer",
            href: "http://www.honolulu.gov/dem"
        }, "City and County of Honolulu Department of Emergency Management")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            title: "Go to site",
            target: "_blank",
            rel: "noreferrer",
            href: "http://www.co.maui.hi.us/departments/CivilDefense/"
        }, "Maui Emergency Management Agency")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            title: "Go to site",
            target: "_blank",
            rel: "noreferrer",
            href: "http://www.kauai.gov/Government/Departments/CivilDefenseAgency/tabid/90/Default.aspx"
        }, "Kauai Emergency Management Agency")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            title: "Go to site",
            target: "_blank",
            rel: "noreferrer",
            href: "http://www.hawaiicounty.gov/civil-defense/"
        }, "Hawai'i County Emergency Management Agency")))), self.props.selectedRegion.name === self.guamCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, " ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "For questions about evacuation procedures in your community, contact your local emergency management agency:"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("ul", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            title: "Go to Guam Homeland Security Office of Civil Defense",
            target: "_blank",
            rel: "noreferrer",
            href: "http://ghs.guam.gov/"
        }, "Guam Homeland Security Office of Civil Defense")))), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", null, "When Sirens Sound"), self.props.selectedRegion.name === self.hawaiiCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Follow the instructions issued by local officials.")), self.props.selectedRegion.name === self.guamCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "First responders from the government of Guam will drive through villages with sirens and provide information about what to do. Follow the instructions issued by local officials.")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "If you are in the evacuation zone, prepare to move inland. If located outside a tsunami evacuation zone, stay outside of the evacuation zone and limit all non-emergency travel."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "For strong local earthquakes, if you have access to an undamaged concrete or steel reinforced building", self.showExtraLegned && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", null, " of ten or more stories, move to the fourth floor, or above, and stay put."), !self.showExtraLegned && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", null, " of six or more stories, move above the third floor and stay put.")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "For distance-source tsunamis, you may have more time to react. A Tsunami Warning will be issued three or more hours before the estimated arrival time.  If you are in the evacuation zone when the warning sirens sound, prepare to move inland, or if you have access to a concrete or steel reinforced building of six or more stories, move above the third floor and stay put."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("ul", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Avoid traffic gridlock!"), " It may be safer and more efficient to walk out of the tsunami evacuation zone."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Remain outside the evacuation zone"), " until local officials tell you that it is safe to return."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Do not use your telephone or make calls on your cell phone"), " except for emergencies (texting and data use is ok)."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Save yourself"), ", not your possessions."), self.props.selectedRegion.name === self.hawaiiCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Remember, all public schools in tsunami evacuation zones"), " have emergency evacuation plans in the event of a Tsunami Warning.")))), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("article", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h1", {
            class: "section-head"
        }, "Tsunami Plan"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "You cannot prevent a tsunami, but you can be prepared for one. Actions you take now could save your life and the lives of your loved ones."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", null, "Develop a Family Emergency Plan"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Prepare yourself and your family for a disaster by making an emergency plan. Your family may not be together when disaster strikes, so it is important to plan in advance."), self.props.selectedRegion.name === self.hawaiiCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Create your ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://dod.hawaii.gov/hiema/get-ready/prepare-your-family/",
            title: "Download PDF",
            target: "_blank",
            rel: "noreferrer"
        }, "Family Emergency Plan"), ", and visit the ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://dod.hawaii.gov/hiema/public-resources/preparedness-information/",
            target: "_blank",
            rel: "noreferrer"
        }, "Hawai\u2018i Emergency Management Agency"), " website for more preparedness information.")), self.props.selectedRegion.name === self.guamCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Create your ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://www.ghs.guam.gov/outreach/citizens-preparedness/make-plan",
            title: "Download PDF",
            target: "_blank",
            rel: "noreferrer"
        }, "Family Emergency Plan"), ", and visit the ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://www.ghs.guam.gov/programs/natural-disasters/tsunamis",
            target: "_blank",
            rel: "noreferrer"
        }, "Guam Civil Defense"), " website for more preparedness information.")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Don\u2019t Forget about Your Pets")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Have ", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "http://www.ready.gov/caring-animals",
            target: "_blank",
            rel: "noreferrer"
        }, "preparations"), " in place to care for your pets in case you are ordered to evacuate."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "clearfix"
        }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", null, "Assemble an Emergency Preparedness Kit"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Emergency kits should contain the essentials your family needs to survive during a disaster. You may be on your own for three days or more before emergency personnel reach you."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://www.ready.gov/sites/default/files/2020-03/ready_emergency-supply-kit-checklist.pdf",
            title: "Download the Emergency Preparedness Kit Checklist",
            target: "_blank",
            rel: "noreferrer",
            class: "btn-default block"
        }, "Access and develop your emergency preparedness kit"), "."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", null, "Plan Ahead"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Become familiar with potential evacuation routes, develop an evacuation plan, and update your plan when issues arise."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Practice your evacuation plan at least twice a year with your family so that when a tsunami occurs, you are prepared to act!"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Keep in mind that hundreds of families in your area share the same concerns, and it may be difficult to access supplies because of shortages and competition."), self.props.selectedRegion.name === self.hawaiiCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", null, "Sign Up"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Sign up to be included in your local emergency notification system"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("ul", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            title: "Go to site",
            target: "_blank",
            rel: "noreferrer",
            href: "http://ww2.citywatchonline.com/Public/Signup.aspx?SUID=jMsd45DCLtpnkuC41zEKNw===",
            class: "btn-default signup-btn"
        }, "Hawaii")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            title: "Go to site",
            target: "_blank",
            rel: "noreferrer",
            href: "http://www.co.maui.hi.us/list.aspx",
            class: "btn-default signup-btn"
        }, "Maui")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            title: "Go to site",
            target: "_blank",
            rel: "noreferrer",
            href: "https://countyofkauai.bbcportal.com/",
            class: "btn-default signup-btn"
        }, "Kauai")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            title: "Go to site",
            target: "_blank",
            rel: "noreferrer",
            href: "http://www.honolulu.gov/dem/preparedness/stay-informed.html",
            class: "btn-default signup-btn"
        }, "Oahu"))))), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("article", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h1", {
            class: "section-head"
        }, "Tsunami Risk"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Knowledge is safety. To reduce your risk, know your tsunami facts."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", null, "What is a tsunami?"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "A tsunami (Japanese for \u201Charbor waves\u201D) is a series of ocean waves produced by a sudden rise or fall in the earth\u2019s crust, most commonly caused by an earthquake or underwater landslide."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "In the open ocean, tsunami waves cannot be seen or felt by ships or airplanes because the waves are actually hundreds of miles wide, with a height of only a few feet. But as the waves approach the coast, their height increases dramatically and can be very destructive when they reach the shore."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://youtu.be/OLZA4wMaFf0",
            title: "watch video",
            target: "_blank",
            rel: "noreferrer"
        }, "Tsunami Mikenna educational video")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h2", null, "Understand the Threat"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("ol", null, self.props.selectedRegion.name === self.hawaiiCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Tsunamis are Hawai'i's number one"), " natural disaster killer.")), self.props.selectedRegion.name === self.guamCode && (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Tsunamis are Guam's number one"), " natural disaster killer.")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "All low-lying coastal areas, harbors, streams, and rivers"), " in Hawai\u2018i are vulnerable to tsunami impacts."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("strong", null, "Tsunamis can occur at any time"), ". Earthquakes or landslides that may trigger tsunamis cannot be forecast.")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h3", null, "Local Tsunamis vs. Distant Source Tsunamis"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "Locally generated tsunamis can arrive at the coast within minutes, even before a warning can be issued."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("p", null, "All islands are also vulnerable to distant-source tsunamis. These tsunamis result from distant earthquakes or landslides in places like Chile, Alaska, and Japan, and can arrive within hours."), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h3", null, "Visit these resources for additional tsunami information:"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("ul", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "http://itic.ioc-unesco.org/index.php",
            target: "_blank",
            rel: "noreferrer"
        }, "International Tsunami Information Center")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "http://www.nws.noaa.gov/om/Tsunami/index.html",
            target: "_blank",
            rel: "noreferrer"
        }, "National Weather Service Tsunami Safety Website")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "http://www.tsunami.noaa.gov/",
            target: "_blank",
            rel: "noreferrer"
        }, "NOAA Tsunami Website")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "http://tsunami.org/",
            target: "_blank",
            rel: "noreferrer"
        }, "Pacific Tsunami Museum")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://www.meted.ucar.edu/training_module.php?id=813",
            target: "_blank",
            rel: "noreferrer"
        }, "Tsunami Strike! Pacific Edition")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("li", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: "https://ndptc.hawaii.edu/",
            target: "_blank",
            rel: "noreferrer"
        }, "National Disaster Preparedness Training Center")))))));
    }
}




var $9b79906539a3f14c$exports = {};
$9b79906539a3f14c$exports = $parcel$resolve("7NffC");


var $a760cc740862b93d$exports = {};
$a760cc740862b93d$exports = $parcel$resolve("lljYM");


var $cf89eb94bd058f85$exports = {};
$cf89eb94bd058f85$exports = $parcel$resolve("bpH67");



class $d5ba0b460d336c36$export$2e2bcd8739ae039 extends (0, $58eedc976c0db041$export$16fa2f45be04daa8) {
    constructor(){
        super();
        this.navigationButtons = [];
        this.state = {
            showNavigation: false
        };
    }
    toggleMobileNavigation() {
        this.setState({
            showNavigation: !this.state.showNavigation
        });
    }
    render() {
        const self = this;
        return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $58eedc976c0db041$export$ffb0004e005737fa), null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("header", {
            class: "site-header",
            role: "banner"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("hgroup", {
            class: "brand float-left"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "logo float-left"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9b79906539a3f14c$exports))),
            alt: "International Tsunami Symbol",
            width: "85"
        })), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("h1", null, "Tsunami Aware")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
            role: "button",
            class: "mobilize-toggle float-right",
            onclick: ()=>self.toggleMobileNavigation()
        }, "Maps", (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("span", {
            class: "text-hidden"
        }, "Menu")), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: `mobilize dropdown-menu ${self.state.showNavigation ? 'is-open' : ''}`
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("nav", {
            class: "site-header-nav",
            role: "navigation"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($3839d5208e8bbfba$exports))).map((region)=>{
            return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
                key: region.name,
                ref: (r)=>self.navigationButtons.push(r),
                class: self.props.selectedRegion && region.name === self.props.selectedRegion.name ? 'active' : '',
                onclick: ()=>self.props.onChangeRegion(region),
                "data-ga": `Nav: ${region.title}`
            }, region.name);
        })))), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("div", {
            class: "share-tools float-right"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftsunami.coast.noaa.gov%2F#/',
            target: "_blank",
            rel: "noreferrer",
            class: "share-link",
            "button-click-animation": true,
            "data-ga": "Share: Facebook"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a760cc740862b93d$exports))),
            alt: "Share on Facebook"
        })), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("a", {
            href: 'https://twitter.com/intent/tweet?user-share&text=Use%20this%20mobile%20app%20to%20explore%20tsunami%20evacuation%20zones%20for%20Guam%20and%20Hawaii&tw_p=tweetbutton&url=https%3A%2F%2Ftsunami.coast.noaa.gov/',
            target: "_blank",
            rel: "noreferrer",
            class: "share-link",
            "button-click-animation": true,
            "data-ga": "Share: Twitter"
        }, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($cf89eb94bd058f85$exports))),
            alt: "Share on Twitter"
        })))));
    }
}



class $98569f8695bb8dce$var$WindowService {
    geolocate() {
        return new Promise((resolve, reject)=>{
            if (!window.navigator) {
                console.error('Geolocation is not supported');
                reject(new Error('Geolocation is not supported'));
            } else window.navigator.geolocation.getCurrentPosition((position)=>{
                resolve(position);
            }, (error)=>{
                console.error(error);
                reject(error);
            });
        });
    }
    getUrl() {
        return window.location.href;
    }
}
var $98569f8695bb8dce$export$2e2bcd8739ae039 = new $98569f8695bb8dce$var$WindowService();


class $a5cdf3e6df1d171b$export$2e2bcd8739ae039 extends (0, $58eedc976c0db041$export$16fa2f45be04daa8) {
    constructor(){
        super();
        this.state = {
            isTsunamiInfoOpen: false,
            isImportantInfoOpen: false,
            isFooterOpen: false,
            selectedRegion: (0, (/*@__PURE__*/$parcel$interopDefault($3839d5208e8bbfba$exports)))[0]
        };
    }
    openImportantInfo() {
        if (!this.state.isImportantInfoOpen) this.setState({
            isImportantInfoOpen: true
        });
    }
    closeImportantInfo() {
        if (this.state.isImportantInfoOpen) this.setState({
            isImportantInfoOpen: false
        });
    }
    openTsunamiInfo() {
        if (!this.state.isTsunamiInfoOpen) this.setState({
            isTsunamiInfoOpen: true
        });
    }
    closeTsunamiInfo() {
        if (this.state.isTsunamiInfoOpen) this.setState({
            isTsunamiInfoOpen: false
        });
    }
    openFooter() {
        if (!this.state.isFooterOpen) this.setState({
            isFooterOpen: true
        });
    }
    closeFooter() {
        if (this.state.isFooterOpen) this.setState({
            isFooterOpen: false
        });
    }
    async componentDidMount() {
        // set default region
        // zoom in on a predefined region if that's where the user lives if they have navigation permission, otherwise Hawaii
        let defaultRegion = (0, (/*@__PURE__*/$parcel$interopDefault($3839d5208e8bbfba$exports))).length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($3839d5208e8bbfba$exports)))[0] : null;
        try {
            const position = await (0, $98569f8695bb8dce$export$2e2bcd8739ae039).geolocate();
            const point = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            for(let i = 0; i < (0, (/*@__PURE__*/$parcel$interopDefault($3839d5208e8bbfba$exports))).length; i++){
                const region = (0, (/*@__PURE__*/$parcel$interopDefault($3839d5208e8bbfba$exports)))[i];
                if (google.maps.geometry.spherical.computeDistanceBetween(region.mapOptions.center, point) <= region.nearbyDistanceMeters) {
                    defaultRegion = {
                        ...region
                    };
                    defaultRegion.mapOptions = {
                        ...region.mapOptions
                    };
                    defaultRegion.mapOptions.center = point;
                    defaultRegion.mapOptions.zoom = 15;
                    break;
                }
            }
        } catch (err) {
        // do nothing
        }
        if (defaultRegion) this.changeRegion(defaultRegion);
    }
    changeRegion(region) {
        this.setState({
            selectedRegion: region
        });
        (0, $0236e83dd00b8ae9$export$2e2bcd8739ae039).changeRegion(region);
    }
    render() {
        const self = this;
        return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $58eedc976c0db041$export$ffb0004e005737fa), null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $32ff908c8de8b49f$export$2e2bcd8739ae039), null), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $d5ba0b460d336c36$export$2e2bcd8739ae039), {
            onChangeRegion: (region)=>self.changeRegion(region),
            selectedRegion: self.state.selectedRegion
        }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $7e0737d55809caa4$export$2e2bcd8739ae039), {
            openTsunamiInfo: ()=>self.openTsunamiInfo(),
            openImportantInfo: ()=>self.openImportantInfo(),
            selectedRegion: self.state.selectedRegion
        }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $2209c6e17d6af860$export$2e2bcd8739ae039), null), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)("button", {
            class: "btn-footer-toggle btn-dark",
            onclick: ()=>self.openFooter(),
            "data-ga": "About"
        }, "About"), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $d3073650918105ac$export$2e2bcd8739ae039), {
            close: ()=>self.closeTsunamiInfo(),
            isOpen: self.state.isTsunamiInfoOpen,
            selectedRegion: self.state.selectedRegion
        }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $6112bc75225f2df5$export$2e2bcd8739ae039), {
            close: ()=>self.closeImportantInfo(),
            isOpen: self.state.isImportantInfoOpen
        }), (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $f8f3fe42a902eb30$export$2e2bcd8739ae039), {
            close: ()=>self.closeFooter(),
            isOpen: self.state.isFooterOpen
        }));
    }
}


class $7352e52306ac0b13$export$86fbec116b87613f {
    constructor(selector){
        this.rootElement = document.querySelector(selector);
    }
    get app() {
        return (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $58eedc976c0db041$export$ffb0004e005737fa), null, (0, $58eedc976c0db041$export$c8a8987d4410bf2d)((0, $a5cdf3e6df1d171b$export$2e2bcd8739ae039), null));
    }
    init() {
        (0, $58eedc976c0db041$export$b3890eb0ae9dca99)(this.app, this.rootElement);
    }
}



// TODO chat nikolay when all done and pushed to QA for compliance test
const $aa459f0fea9822fe$var$app = new (0, $7352e52306ac0b13$export$86fbec116b87613f)('body');
$aa459f0fea9822fe$var$app.init();


//# sourceMappingURL=tsunami_frontend.876795b3.js.map
